import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { SvgIconComponent } from 'angular-svg-icon';
import { DayJSDateFormat } from '@app/core/enums/date-format.enum';
import { DayjsPipe } from '@app/shared/pipes/dayjs/dayjs.pipe';
import { ITranslationSubscription } from '@app/core/interfaces/localization';
import { DialogEventBadgesComponent } from '@app/main/leak-detection/dialogs/dialog-event/components/dialog-event-badges/dialog-event-badges.component';
import { DialogEventState } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-state.service';
import { DialogEventTabsService } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-tabs.service';
import { DialogEventEditor } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-editor.enum';

@Component({
  selector: 'gc-dialog-event-header',
  standalone: true,
  imports: [
    AsyncPipe,
    TranslateDirective,
    TranslatePipe,
    DayjsPipe,
    Button,
    Tooltip,
    SvgIconComponent,
    DialogEventBadgesComponent,
  ],
  templateUrl: './dialog-event-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class DialogEventHeaderComponent {
  protected readonly dialogState = inject(DialogEventState);
  protected readonly tabs = inject(DialogEventTabsService);

  public title = input.required<ITranslationSubscription>();

  public closeRequested = output<void>();

  protected readonly dateFormat = DayJSDateFormat.DMMMYYYYHHmm;

  protected readonly draft = this.dialogState.draft;
  protected readonly createdAt = computed(() => this.dialogState.event()?.createdAt ?? null);
  protected readonly updatedAt = this.dialogState.updatedAt;
  protected readonly showBadges = computed(() => {
    const editor = this.tabs.editor();

    return !this.dialogState.isCreating() && editor !== DialogEventEditor.Status && editor !== DialogEventEditor.Result;
  });

  protected readonly isAutoCreated = computed(() => this.dialogState.event()?.autoCreated ?? false);
}
